/* eslint-disable no-undef */
/* eslint-env jquery FWP */
$( document ).on( 'facetwp-loaded', () => {
  if ( FWP == undefined ) {
    return;
  }
  $( '.fs-job__department-title' ).each( ( dI, department ) => {
    const title = $( department ).data( 'department-title' );
    const departmentDupes = $( '[data-department-title="' + title + '"]' );
    for ( let i = 1; i < departmentDupes.length; i++ ) {
      const dupes = departmentDupes[i];
      dupes.remove();
    }
  } );

  if ( $( '.bs-section--careers-job-openings' ) ) {
    if ( FWP.settings.pager.page >= FWP.settings.pager.total_pages ) {
      $( '.facetwp-facet-see_more' ).hide();
    } else {
      $( '.facetwp-facet-see_more' ).show();
    }
  }
} );

const careerOpeningsSection = $( '.bs-section--careers-job-openings' );
$( document ).on( 'fs:opened', () => {
  if ( careerOpeningsSection && FWP.template == 'careers' ) {
    const facetDropdownOptions = $( '.fs-wrap, .single > .fs-options' );

    facetDropdownOptions.each( ( i, facetDropdownOptions ) => {
      let singleSelect = $( facetDropdownOptions );
      let optionIsSelected = false;
      let singleSelectOptions = singleSelect.find( '.fs-option' );
      singleSelectOptions.each( ( i, singleSelectOptions ) => {
        let singleOption = $( singleSelectOptions );
        if ( singleOption.hasClass( 'selected' ) ) {
          optionIsSelected = true;
        }
      } );

      if ( !optionIsSelected ) {
        singleSelectOptions.first().addClass( 'selected' );
      }
    } );
  }
} );
